
/* eslint-disable @typescript-eslint/no-shadow */
export namespace AssetType {
  export enum AssetType {
    RICH_TEXT_DOCUMENTS = "RICH_TEXT_DOCUMENTS",
  }

  export interface AssetTypeDTO {
    case: string;
  }

  export const fromDTO = (dto: AssetTypeDTO): AssetType => {
    if (dto === undefined || dto === null) {
      throw new InvalidAssetTypeError(
        `Invalid DTO ${dto} provided for AssetType.AssetType`
      );
    }
    switch (dto.case) {
      case "RICH_TEXT_DOCUMENTS":
        return AssetType.RICH_TEXT_DOCUMENTS;
      default:
        throw new InvalidAssetTypeError(
          `Case ${dto.case} is not valid case of AssetType.AssetType`
        );
    }
  };

  export const toDTO = (assetType: AssetType): AssetTypeDTO => {
    const enumDTO = {
      case: AssetType[assetType],
    };
    return enumDTO;
  };
}

export class InvalidAssetTypeError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidAssetTypeError";
  }
}
export class InvalidAssetTypeRichTextDocumentsError extends InvalidAssetTypeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidAssetTypeRichTextDocumentsError";
  }
}
